import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import DateRangeFilter from "components/DateRangeFilter/DateRangeFilter";
import { useDateFilter } from "Hooks/useDateFilter";
import { SCREEN_KEYS } from "constants/screenKeys";
import { getCurrentDate, getFirstDayOfMonth } from "Utils/dateUtils";
import DisReportDp from "./DisReportDp";

export default function DisReport() {
  const { fromDate, toDate, setFromDate, setToDate } = useDateFilter(
    SCREEN_KEYS.DIS_REPORT,
    { fromDate: getFirstDayOfMonth(), toDate: getCurrentDate() }
  );

  const handleFromDateChange = (value) => {
    setFromDate(value);
    if (value > toDate) setToDate(value);
  };

  const handleToDateChange = (value) => {
    if (value < fromDate) return;
    setToDate(value);
  };

  return (
    <Box
      minH="100vh"
      bg="gray.50"
      pt={{ base: "10vh", md: "13vh" }}
      px={{ base: 4, md: 8 }}
      pb={8}
    >
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align={{ base: "flex-start", md: "center" }}
        gap={4}
        mb={6}
      >
        <Box>
          <Heading size="lg" color="gray.800" mb={1}>
            DIS Report
          </Heading>
          <Text color="gray.500" fontSize="sm">
            Daily Upload Status — General &amp; Modern Trade
          </Text>
        </Box>

        <DateRangeFilter
          fromDate={fromDate}
          toDate={toDate}
          onFromDateChange={handleFromDateChange}
          onToDateChange={handleToDateChange}
        />
      </Flex>

      <DisReportDp fromDate={fromDate} toDate={toDate} />
    </Box>
  );
}